import React from 'react'
import { useLocation } from 'react-router-dom'
import LoginMessage from 'components/common/login-message'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import styles from './index.module.css'

const InstructionsSent = (): React.ReactNode => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const email = decodeURIComponent(searchParams.get('email') || '')
  const from = searchParams.get('from')
  let returnUrl = '/login'
  let returnMessage = 'Back to Sign in'

  if (from === 'settings') {
    returnUrl = '/settings/security'
    returnMessage = 'Back to Settings'
  }

  return (
    <LoginMessage helmet="Email Sent!" title="Email Sent!">
      <p className={styles.instructionsSentText}>
        Email has been sent to {email} with instructions on resetting your
        password.
      </p>
      <ButtonContainer centered>
        <Button link={returnUrl} appearance="primary" caption={returnMessage} />
      </ButtonContainer>
    </LoginMessage>
  )
}

export default InstructionsSent
